import React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import { Stack, TextField } from '@mui/material'

interface FRAutoCompleteFilterSelectProps {
  optionsSymbol: string[]
  filterSymbol: string
  setFilterSymbol: React.Dispatch<React.SetStateAction<string>>
}

const FRAutoCompleteFilterSelect: React.FC<FRAutoCompleteFilterSelectProps> = (props) => {
  const { optionsSymbol, filterSymbol, setFilterSymbol } = props

  return (
    <Stack>
      <Autocomplete
        id='funding-rate-chart-filter-symbol'
        options={optionsSymbol}
        value={filterSymbol}
        onInputChange={(_event, value: string | null) => {
          setFilterSymbol(value == null ? '' : value)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Symbol'
            InputProps={{
              ...params.InputProps,
            }}
          />
        )}
        size='small' fullWidth freeSolo
        sx={{ marginBottom: 1 }}
      />
    </Stack>
  )
}

export default FRAutoCompleteFilterSelect
